import type { Ref } from '@wix/materializer'
import type { Component } from '@wix/thunderbolt-becky-types'
import { createRefInResolvedRefsNamespaces } from '../../../byRefUtils'
import {
	GHOST_REF_COMP_STRUCTURE_OVERRIDES,
	KEEP_GHOST_COMPONENTS_REF,
	RESOLVED_REF_IS_GHOST_COMPONENT_ASPECT,
} from '../../../constants'
import { createByRefsisCompNode } from '../../../compNodeUtils'
import type { isGhostCompToViewItem } from './isGhostComponent'

type StructureDeps = {
	ghostComponent: Ref<isGhostCompToViewItem>
	keepGhostComponents: Ref<boolean>
}

export const structure = createByRefsisCompNode<StructureDeps, Component>({
	getDependencies: ({ id }) => ({
		ghostComponent: createRefInResolvedRefsNamespaces<isGhostCompToViewItem>(
			RESOLVED_REF_IS_GHOST_COMPONENT_ASPECT,
			id
		),
		keepGhostComponents: KEEP_GHOST_COMPONENTS_REF,
	}),
	toViewItem: (inflatedStructure, { ghostComponent, keepGhostComponents }) =>
		ghostComponent?.isGhostComp && !keepGhostComponents
			? {
					...inflatedStructure,
					...GHOST_REF_COMP_STRUCTURE_OVERRIDES,
			  }
			: inflatedStructure,
})
